const { REACT_APP_DOWNLOAD_URL } = process.env;

const updateCellLink = (cell) => {
    if (cell)
        cell.link = `${REACT_APP_DOWNLOAD_URL}/?cell=${cell.name}&lang=${cell.language?.code}&slide=1`;
};

export default updateCellLink;
